// Mini SuperOver result — detail.t1: { score: [{ing, oc, nat, run, wkt,
// card}], win, winnat, rdesc "IND : 0 | AUS : 6" }. Reference: five-cricket-result,
// dono innings ki over-wise tables (4 ball columns, wicket = "ww" text-playerb,
// Run/Over + cumulative Score runs/wkts nationcard cells).
// Super Over / Super Over 2 are 6-ball overs; Mini Super Over (superover3) has 4.
// A hard-coded 4 used to drop balls 5-6 from the result (reference shows all six).
const BALLS_PER_OVER = { superover: 6, superover2: 6, superover3: 4 };

export default function SuperOverResult({ detail, gameType }) {
  const ballCols = Array.from({ length: BALLS_PER_OVER[gameType] || 4 }, (_, i) => i);
  const scores = detail?.score || [];
  const inn1 = scores.filter((s) => s.ing === 1);
  const inn2 = scores.filter((s) => s.ing === 2);
  const team1Name = inn1[0]?.nat || 'IND';
  const team2Name = inn2[0]?.nat || 'AUS';
  const winnerText = detail?.winnat || '';
  const rdesc = detail?.rdesc || '';

  const renderInning = (teamName, balls, lastTable) => {
    const overs = [...new Set(balls.map((b) => b.oc || 1))].sort((a, b) => a - b);
    let cumRuns = 0;
    let cumWkts = 0;
    return (
      <div className={`table-responsive${lastTable ? '' : ' mb-0'}`}>
        <table className="table">
          <thead>
            <tr>
              <th className="text-center"><b><span className="text-success">{teamName}</span></b></th>
              {ballCols.map((i) => (
                <th key={i} className="text-center"><b>{i + 1}</b></th>
              ))}
              <th className="text-center"><b>Run/Over</b></th>
              <th className="text-center"><b>Score</b></th>
            </tr>
          </thead>
          <tbody>
            {overs.map((oc) => {
              const overBalls = balls.filter((b) => (b.oc || 1) === oc);
              const overRuns = overBalls.reduce((s, b) => s + (b.run || 0), 0);
              cumRuns += overRuns;
              cumWkts += overBalls.filter((b) => b.wkt).length;
              return (
                <tr key={oc}>
                  <td className="text-center"><b>Over {oc}</b></td>
                  {ballCols.map((i) => {
                    const b = overBalls[i];
                    return (
                      <td key={i} className="text-center">
                        {b && (
                          <span className={b.wkt ? 'text-playerb' : ''}>
                            {b.wkt ? 'ww' : String(b.run ?? '')}
                          </span>
                        )}
                      </td>
                    );
                  })}
                  <td className="text-center nationcard">{overRuns}</td>
                  <td className="text-center nationcard">
                    {`\n                  ${cumRuns}/${cumWkts}\n               `}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="row row5 align-items-center five-cricket-result">
      <div className="col-12">
        <div className="text-right mt-3 score-head">
          {'\n          Winner:\n          '}
          <span className="text-success">{winnerText}</span>
          {'\n          | ' + rdesc + '\n        '}
        </div>
        {' '}
        <h4 className="mb-0">First Inning</h4>
        {' '}
        {renderInning(team1Name, inn1, false)}
        {' '}
        <h4 className="mb-0">Second Inning</h4>
        {' '}
        {renderInning(team2Name, inn2, true)}
      </div>
    </div>
  );
}
